import React, { useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import { LocaleContext } from './LocaleProvider';

const Translate = ({ ...props }) => {
  const localeContext = useContext(LocaleContext);
  return <FormattedMessage {...props} />;
};

export default Translate;
